<template>
  <div class="metafield-edit-text">
    <BaseTextarea
      :data-vv-as="field.type"
      :minHeight="subFormData.rows * 25"
      :name="$attrs.name"
      :value="value"
      :label="field.label"
      :hint="hint"
      @input="onInput"
      :validate="validator()"
      ></BaseTextarea>
  </div>
</template>

<script>
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  inject: ['$validator'],
  mixins: [ forSingleMetafield(true) ],
  props: {
    field: Object,
    value: String,
    hint: String,
    subFormData: Object
  },
  methods: {
    onInput (val) {
      this.$emit('input', val === '' ? null : val)
    },
    validator () {
      return `min:${this.subFormData.min}|max:${+this.subFormData.max || Infinity}`
    }
  },
}
</script>

<style lang="scss">
  .metafield-edit-text {

  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditTextarea.vue